import { Popover } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../../components/common/BriaButton/BriaButton";
import styles from "../PlaygroundImageOverlay.module.scss";

const ImageOverlayShareButton = () => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.textToImage.imageOverlay" });
	const [shareAnchorEl, setShareAnchorEl] = useState<HTMLButtonElement>();

	// const handleOpenSharePopover = (event: React.MouseEvent<HTMLButtonElement>) => {
	// 	setShareAnchorEl(event.currentTarget);
	// };

	const handleCloseSharePopover = () => {
		setShareAnchorEl(undefined);
	};

	return (
		<Popover
			open={!!shareAnchorEl}
			onClose={handleCloseSharePopover}
			anchorEl={shareAnchorEl}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
			transformOrigin={{
				vertical: "top",
				horizontal: "left",
			}}
			slotProps={{
				paper: {
					className: styles.popover,
				},
			}}
		>
			<BriaButton>{t("campaign")}</BriaButton>
			<BriaButton>{t("report")}</BriaButton>
			<BriaButton>{t("save")}</BriaButton>
			<BriaButton>{t("export")}</BriaButton>
		</Popover>
	);
};

export default observer(ImageOverlayShareButton);
